import CandidateAssessment from '../assessment/assessment.entity';
import JobApplication from '../job/job-application.entity';

export default class Candidate {
  id: string;

  name: string;

  email: string;

  phone: string;

  linkedinUrl: string;

  jobApplications: JobApplication[];

  assessments: CandidateAssessment[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.email = obj.email || '';
    this.phone = obj.phone || '';
    this.linkedinUrl = obj.linkedinUrl || '';
    this.jobApplications = obj.jobApplications || [];
    this.assessments = obj.assessments || [];
  }
}
